import { AnimatedChartCompact } from "~/componentsDS/OestraChart";
import Paragraph from "~/componentsDS/Typography/Paragraph";
import { cn } from "~/lib/utils";
import Lead from "~/componentsDS/Typography/Lead";
import { InteractiveTimelineVariant } from "./types";

const LEGEND = [
    { label: "Progesterone", color: "bg-primary200" },
    { label: "Estradiol", color: "bg-primary300" },
    { label: "Testosterone", color: "bg-gray400" },
];

const LegendList = ({ className, compact }: { className?: string; compact?: boolean }) => (
    <ul className={cn("flex gap-2.5", !compact && "lg:gap-5", className)}>
        {LEGEND.map(({ label, color }) => (
            <li key={label} className={cn("flex items-center gap-[3px]", !compact && "lg:gap-1.5")}>
                <div className={cn("w-2 h-2 rounded-full", !compact && "lg:w-2.5 lg:h-2.5", color)} />
                <Paragraph className={cn("text-[12px] text-primary500 pt-[2px]", !compact && "lg:text-[16px]")}>
                    {label}
                </Paragraph>
            </li>
        ))}
    </ul>
);

const ChartCard = ({ variant = "default" }: { variant?: InteractiveTimelineVariant }) => {
    const isCompact = variant === "compact";

    return (
        <div className={cn(
            "px-8 py-6 h-full",
            isCompact ? "flex flex-col lg:justify-between lg:flex-row lg:items-center lg:gap-6 lg:px-[22px] lg:py-3" : "flex flex-col",
        )}>
            <div className={cn(isCompact && "lg:flex lg:flex-col lg:shrink-0 lg:self-center")}>
                <Lead
                    size="xs"
                    font="featureDisplay"
                    className={cn(
                        "hidden md:block text-primary500 mb-4",
                        isCompact ? "lg:text-[22px] lg:text-left" : "lg:text-[28px] text-center",
                    )}
                >
                    How Menopause Oestra<sup>®</sup> gets you <br /> back to feeling like you
                </Lead>
                {isCompact && <LegendList compact className="hidden lg:flex lg:flex-col lg:mx-auto" />}
            </div>

            <div className={cn(
                "flex-1 min-h-0 flex",
                isCompact
                    ? "w-full max-[399px]:max-w-[275px] max-w-[309px] md:max-w-[430px] lg:max-w-none mx-auto lg:mx-0 lg:max-w-[330px]"
                    : "w-full max-[399px]:max-w-[275px] max-w-[309px] md:max-w-[430px] lg:max-w-[535px] mx-auto",
            )}>
                <AnimatedChartCompact />
            </div>

            <LegendList className={cn(
                "justify-center mt-auto",
                isCompact && "lg:hidden",
            )} />
        </div>
    );
};

export default ChartCard;
